export enum ETokenStatus {
	EXPIRED = "EXPIRED",
	OPEN = "OPEN",
	INVALID = "INVALID",
	USED = "USED",
}
